import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Leaf, ShieldCheck, Truck } from "lucide-react";
import { api } from "../lib/api";
import { priceLabel, whatsappEcoLojaLink } from "../lib/constants";

export default function ProductDetail() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  const [err, setErr] = useState(null);
  const [others, setOthers] = useState([]);

  useEffect(() => {
    setP(null); setErr(null);
    api.get(`/products/${slug}`).then((r) => setP(r.data)).catch(() => setErr("Produto não encontrado."));
    api.get("/products?limit=8").then((r) => setOthers(r.data)).catch(() => {});
  }, [slug]);

  if (err)
    return (
      <div className="container-page py-24" data-testid="product-detail-not-found">
        <p className="text-forest-900/70">{err}</p>
        <Link to="/eco-loja" className="btn-outline mt-6">Voltar para a loja</Link>
      </div>
    );

  if (!p) return <div className="container-page py-24 text-forest-900/60">Carregando...</div>;

  return (
    <div data-testid="product-detail-page" className="py-16">
      <div className="container-page">
        <Link to="/eco-loja" data-testid="back-to-shop-link" className="inline-flex items-center gap-2 text-sm text-forest-700 hover:text-copaiba-700 mb-8">
          <ArrowLeft className="w-4 h-4" /> Voltar para a loja
        </Link>

        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div className="aspect-[4/5] overflow-hidden bg-cream-200">
            <img src={p.image_url} alt={p.name} className="w-full h-full object-cover" />
          </div>

          <div>
            <div className="eyebrow mb-3">{p.category}</div>
            <h1 className="font-display text-4xl md:text-5xl text-forest-900 leading-tight">{p.name}</h1>
            <div className="font-display text-3xl text-copaiba-700 mt-4">{priceLabel(p.price)}</div>
            <div className="section-divider my-7" />
            <p className="text-forest-900/85 leading-relaxed">{p.description}</p>

            {p.highlights && p.highlights.length > 0 && (
              <ul className="mt-8 space-y-3">
                {p.highlights.map((h, i) => (
                  <li key={i} className="flex items-start gap-3 text-forest-900/85">
                    <Leaf className="w-4 h-4 text-copaiba-700 mt-1" />
                    <span>{h}</span>
                  </li>
                ))}
              </ul>
            )}

            <a
              href={whatsappEcoLojaLink(`Olá! Tenho interesse em: ${p.name}. Poderia me informar disponibilidade e valor?`)}
              target="_blank"
              rel="noreferrer"
              data-testid="detail-whatsapp-buy"
              className="btn-whatsapp mt-10 w-full md:w-auto !px-8 !py-4 text-base"
            >
              Consultar pelo WhatsApp
            </a>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-10 pt-8 border-t border-cream-400 text-sm">
              <div className="flex items-start gap-3">
                <ShieldCheck className="w-5 h-5 text-forest-700 mt-0.5" />
                <div>
                  <div className="font-medium text-forest-900">Origem rastreada</div>
                  <div className="text-forest-900/65">Da árvore à sua casa</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Leaf className="w-5 h-5 text-forest-700 mt-0.5" />
                <div>
                  <div className="font-medium text-forest-900">Manejo sustentável</div>
                  <div className="text-forest-900/65">Floresta em pé</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Truck className="w-5 h-5 text-forest-700 mt-0.5" />
                <div>
                  <div className="font-medium text-forest-900">Envio para todo BR</div>
                  <div className="text-forest-900/65">Combinamos pelo WhatsApp</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {others.filter((o) => o.slug !== p.slug).length > 0 && (
          <section className="mt-24">
            <h2 className="font-display text-3xl text-forest-900 mb-8">Outros produtos da Eco Loja</h2>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {others.filter((o) => o.slug !== p.slug).slice(0, 4).map((o) => (
                <Link
                  key={o.id}
                  to={`/eco-loja/${o.slug}`}
                  data-testid={`related-product-${o.slug}`}
                  className="card-earthy group block"
                >
                  <div className="aspect-[4/5] overflow-hidden">
                    <img src={o.image_url} alt={o.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                  <div className="p-5">
                    <div className="eyebrow mb-1">{o.category}</div>
                    <div className="font-display text-xl text-forest-900 leading-tight">{o.name}</div>
                    <div className="text-copaiba-700 font-medium mt-2">{priceLabel(o.price)}</div>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        )}
      </div>
    </div>
  );
}
